import { useRef, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useApi } from "../hooks/useApi";
import Tabs from "../components/ui/Tabs";

export default function Logs() {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const initialized = useRef(false);
  const { apiCall } = useApi();
  const [logFiles, setLogFiles] = useState([]);
  useEffect(() => {
    const fetchData = async () => {
      if (!initialized.current) {
        initialized.current = true;

        setLoading(true);
        try {
          const files = await apiCall(`logs-get_log_files`);
          const filesdata = await files.json();
          setLogFiles(filesdata.files || []);
          setLoading(false);
        }
        catch (error) {
          setError("Error loading logs.");
        }

      }
    };
    fetchData();
  }, []);


  const clearLog = async (logfile) => {
    try {
      const request = await apiCall(`logs-delete_log_file`, { params: { name: logfile } });
      const response = await request.json();
      if (response.success) {
        //set the file content to empty
        setLogFiles(prevFiles =>
          prevFiles.map((file, idx) =>
            file.label === logfile ? { ...file, content: '' } : file
          )
        );
      }

    }
    catch (error) {
      setError("Error deleting log.");
    }
  }

  if (error) return <p>Error: {error}</p>;
  return (

    <div className="p-6">
      {/* Loading overlay */}
      <div className="flex justify-between items-center mb-4">

        <h1 className="text-2xl font-bold">Log List</h1>

      </div>

      <div className="flex justify-center">
        <Tabs tabs={logFiles} clearLog={clearLog} />
      </div>


    </div>
  );
}
